import React from "react";
import _ from "underscore";

import "./playTriangle.scss";

interface OwnProps {
  size?: number;
}

export const PlayTriangle = ({ size = 100 }: OwnProps) => (
  <div className="play-triangle" style={{ width: `${size}px`, height: `${size}px` }}>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%" viewBox="0 0 100 100">
      <g fill="none" stroke="white">
        <path d="M 5,5 80,50 5,95 z" />
      </g>
    </svg>
  </div>
);
